import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, itemStr, labeledIntro, sectionOpen, str } from './helpers.js';
import type { JsonValueT, PatternSectionT } from '../../schema/index.js';

function portableText(item: JsonValueT): string {
  const directText = itemStr(item, 'text');
  if (directText) return directText;
  if (item === null || typeof item !== 'object' || Array.isArray(item)) return '';
  const children = item.children;
  if (!Array.isArray(children)) return '';
  return children.map((child) => itemStr(child, 'text')).join('');
}

function renderContent(section: PatternSectionT): string {
  const content = section.fields.content;
  if (typeof content === 'string') {
    if (!content) return '';
    return `  <p class="ve-custom__paragraph"${editAttr(section, '/content')}>${escapeHtml(content)}</p>`;
  }
  if (!Array.isArray(content)) return '';
  return content
    .map((item, index) => {
      let text = '';
      if (typeof item === 'string') text = item;
      else text = portableText(item);
      if (!text) return '';
      const contentPath = `/content/${index}`;
      return `  <p class="ve-custom__paragraph"${editAttr(section, contentPath)}>${escapeHtml(text)}</p>`;
    })
    .filter(Boolean)
    .join('\n');
}

/** custom — escaped freeform text plus optional image and Portable-Text-like blocks. */
export function renderCustom(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const image = section.fields.image ?? null;
  const imageUrl = itemStr(image, 'url');
  const imageAlt = itemStr(image, 'alt');
  const content = renderContent(section);
  const parts: string[] = [sectionOpen(section)];
  if (imageUrl) parts.push(`  <img class="ve-custom__image" src="${safeUrl(imageUrl)}" alt="${escapeHtml(imageAlt)}"${editAttr(section, '/image')}>`);
  parts.push(...labeledIntro(section, 'custom', heading, label));
  if (content) parts.push(`  <div class="ve-custom__content">\n${content}\n  </div>`);
  parts.push('</section>');
  return parts.join('\n');
}
